import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
// import { userID } from "../utils/auth";

const Site_url = "https://vipin.hyperofficial.in/";
const Base_url = Site_url + "Master/api/";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

const encryptedUserId = localStorage.getItem("userid") || "";

let userID = null;

try {
  if (encryptedUserId) {
    const bytes = CryptoJS.AES.decrypt(encryptedUserId, SECRET_KEY);
    userID = bytes.toString(CryptoJS.enc.Utf8);

    if (!userID) {
      throw new Error("Decryption Failed This 1: Empty UserID");
    }
  }
} catch (error) {
  console.error("Decryption Error This 2:", error);
  userID = null;
}

const getDecryptedUserID = () => {
  const encryptedUserId = localStorage.getItem("userid") || "";
  try {
    if (encryptedUserId) {
      const bytes = CryptoJS.AES.decrypt(encryptedUserId, SECRET_KEY);
      const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedUserId) throw new Error("Decryption Failed");
      return decryptedUserId;
    }
  } catch (error) {
    console.error("Decryption Error:", error);
  }
  return null;
};

/* =======User Data=========*/
const UserProfileData = (RendomTokenfetch) => {
  const [userData, setuserData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [usernewID, setUserID] = useState(getDecryptedUserID());

  useEffect(() => {
    const checkUserID = () => {
      const storedUserID = getDecryptedUserID();
      if (storedUserID && storedUserID !== usernewID) {
        setUserID(storedUserID);
      }
    };

    window.addEventListener("storage", checkUserID);
    return () => {
      window.removeEventListener("storage", checkUserID);
    };
  }, [usernewID]);

  useEffect(() => {
    if (!usernewID) {
      setError("User ID not found in localStorage");
      return;
    }

    const FetchUserData = async () => {
      setLoading(true);
      try {
        const fdata = new FormData();
        fdata.append("userID", usernewID);

        const response = await axios.post(`${WebsiteAPIurl}userdata`, fdata, {
          headers: { Authorization: RendomTokenfetch },
        });

        if (response.data.Status === "1") {
          setuserData(response.data.userdata);

          const encryptedUserRoll = CryptoJS.AES.encrypt(
            response.data.userdata.role.toString(),
            SECRET_KEY
          ).toString();
          localStorage.setItem("userRoll", encryptedUserRoll);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchUserData();
  }, [usernewID, RendomTokenfetch]);

  return [userData, loading, error];
};

/* =======Website Setting=========*/
const WebsiteSetting = (RendomTokenfetch) => {
  // console.log(Site2Url);
  const [webSetting, setwebSetting] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    const Fetchwebsite = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}website_setting`, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((res) => {
            //  console.log(res.data);
            if (res.data.Status === "1") {
              setwebSetting(res.data.sitedata);
            }
          });
      } catch (err) {
        setError(err.message);
        // alert(err.message);
      } finally {
        setLoading(false);
      }
    };
    Fetchwebsite();
  }, [RendomTokenfetch]);
  return [webSetting, loading, error];
};

/* =======Error Heandling Function=========*/

/* =======All Service Category Data=========*/
const AllServicesCategory = (RendomTokenfetch) => {
  const [serviceCat, setserviceCat] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const FetchcatData = async () => {
      setLoading(true);
      try {
        await axios
          .get(`${WebsiteAPIurl}getallcategory`, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setserviceCat(response.data.catdata);
            } else {
              // console.error("Failed to fetch categories:", response.data.Message);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchcatData();
  }, [RendomTokenfetch]);
  return [serviceCat, loading, error];
};

/* =======All Indian City Data=========*/
const AllIndiaCity = (RendomTokenfetch) => {
  const [CityData, setCityData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchCityData = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      try {
        await axios
          .post(`${WebsiteAPIurl}allIndiaCity`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setCityData(response.data.allcities);
            }
            if (response.data.Status === "0") {
              setCityData("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchCityData();
  }, [RendomTokenfetch]);
  return [CityData, loading, error];
};

/* =======Community Service Data=========*/
const AllCommunityService = (RendomTokenfetch, catID, communityCatslug) => {
  const [servicecat, setservicecat] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  let IDCAT = "";
  let CATSLUG = "";

  catID && catID ? (IDCAT = catID) : (IDCAT = "");
  communityCatslug && communityCatslug
    ? (CATSLUG = communityCatslug)
    : (CATSLUG = "");

  useEffect(() => {
    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();

      fdata.append("cat_id", IDCAT);
      fdata.append("cat_slug", CATSLUG);

      try {
        await axios
          .post(`${WebsiteAPIurl}community_service`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setservicecat(response.data.community_service);
            }
            if (response.data.Status === "0") {
              setservicecat([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  }, [RendomTokenfetch, IDCAT, CATSLUG]);
  return [servicecat, loading, error];
};

/* =======Community Service Questin Data=========*/
const AllCommunityServiceQuestion = (RendomTokenfetch, communitySerSlug) => {
  const [communityservice, setcommunityservice] = useState([]);
  const [serviceQues, setserviceQues] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("service_slug", communitySerSlug);
      try {
        await axios
          .post(`${WebsiteAPIurl}community_serviceQuestion`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setcommunityservice(response.data.community_service);
              setserviceQues(response.data.questions);
            }
            if (response.data.Status === "0") {
              setcommunityservice(response.data.community_service);
              setserviceQues([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  }, [RendomTokenfetch, communitySerSlug]);
  return [communityservice, serviceQues, loading, error];
};
/* =======Community Answear Details Data=========*/
const AllCommunityAnswear = (RendomTokenfetch, questionslug) => {
  const [communitySerAns, setcommunitySerAns] = useState([]);
  const [serviceQues, setserviceQues] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("question_slug", questionslug);
      try {
        await axios
          .post(`${WebsiteAPIurl}community_Answer`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setcommunitySerAns(response.data.answer);
              setserviceQues(response.data.question);
            }
            if (response.data.Status === "0") {
              setcommunitySerAns([]);
              setserviceQues(response.data.question);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  }, [RendomTokenfetch, questionslug]);
  return [communitySerAns, serviceQues, loading, error];
};

/* =======All Customers Upload  Data=========*/
const AllCustomersUploads = async (RendomTokenfetch, leadID, userRoll) => {
  try {
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("lead_id", leadID);

    const response = await axios.post(`${WebsiteAPIurl}userFiles`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });

    if (response.data.Status === "1") {
      return response.data.fileData;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching files:", err);
    return [];
  }
};

/* =======All Vendors Upload  Data=========*/
const AllVendorsUploads = (RendomTokenfetch, leadID, userRoll) => {
  const [uploadData, setuploadData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("lead_id", leadID);

    const FetchServiceCityData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}userVendorFiles`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setuploadData(response.data.fileData);
            } else {
              setuploadData("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServiceCityData();
  }, [RendomTokenfetch, userRoll, leadID]);
  return [uploadData, error, loading];
};
/* =======All Vendors Upload  Data=========*/
const AllCustumertUploads = (RendomTokenfetch, leadID, userRoll) => {
  const [uploadData, setuploadData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("lead_id", leadID);

    const FetchServiceCityData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}customerFiles_showvender`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setuploadData(response.data.fileData);
            } else {
              setuploadData("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServiceCityData();
  }, [RendomTokenfetch, userRoll, leadID]);
  return [uploadData, error, loading];
};

/* =======Community Answear Like  & DisLike Updates=========*/
const AllCommunityAnswearLike = (
  RendomTokenfetch,
  quesID,
  ansID,
  likeStatus
) => {
  const [communitySerAns, setcommunitySerAns] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("question_id", quesID);
      fdata.append("answer_id", ansID);
      fdata.append("status", likeStatus);
      try {
        await axios
          .post(`${WebsiteAPIurl}answer_like`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setcommunitySerAns(response.data.answer);
            }
            if (response.data.Status === "0") {
              setcommunitySerAns([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  }, [RendomTokenfetch, quesID, ansID, likeStatus]);
  return [communitySerAns, loading, error];
};

/* =======ServiceCatWise Data=========*/
const ServiceCatWise = (RendomTokenfetch, category) => {
  const [servicecat, setservicecat] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("slug", category);
      try {
        await axios
          .post(`${WebsiteAPIurl}get_allservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setservicecat(response.data.servicedata);
            }
            if (response.data.Status === "0") {
              setservicecat("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  }, [RendomTokenfetch, category]);
  return [servicecat, loading, error];
};

/* =======Single Cat name Data=========*/
const SingleCatName = (RendomTokenfetch, category) => {
  const [CatName, setCatName] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const Fetchcatname = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("slug", category);
      try {
        await axios
          .post(`${WebsiteAPIurl}getRowcategory`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setCatName(response.data.catdata);
            }
            if (response.data.Status === "0") {
              setCatName("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    Fetchcatname();
  }, [RendomTokenfetch, category]);
  return [CatName, loading, error];
};

/* =======Services Details=========*/
const ServicesDetails = (RendomTokenfetch, serviceSlug) => {
  const [servicedetails, setservicedetails] = useState([]);
  const [serviceplan, setserviceplan] = useState([]);
  const [subservics, setsubservics] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetcServicesDetails = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("slug", serviceSlug);
      try {
        await axios
          .post(`${WebsiteAPIurl}serviceDetails`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setservicedetails(response.data.servicedata);
              setserviceplan(response.data.serviceplan);
              setsubservics(response.data.subservics);
            }
            if (response.data.Status === "0") {
              setservicedetails("");
              setserviceplan("");
              setsubservics("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetcServicesDetails();
  }, [RendomTokenfetch, serviceSlug]);
  return [servicedetails, serviceplan, subservics, loading, error];
};

/* =======Home homesetting=========*/
const Homesetting = (RendomTokenfetch) => {
  const [SettingHome, setSettingHome] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetcServicesDetails = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("status", "1");
      try {
        await axios
          .post(`${WebsiteAPIurl}homepageSetting`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setSettingHome(response.data.homedata);
            }
            if (response.data.Status === "0") {
              setSettingHome("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetcServicesDetails();
  }, [RendomTokenfetch]);
  return [SettingHome, loading, error];
};

/* =======Home Defaults Plans =========*/
const AllHomeDefaultPlans = (RendomTokenfetch, catid, planlimit, limittype) => {
  const [homePlans, sethomePlans] = useState([]);
  const [SerCat, setSerCat] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchHomePlans = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("category", catid);
      fdata.append("limit", planlimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}homePagePlan`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              sethomePlans(response.data.planData);
              setSerCat(response.data.catdata);
            }
            if (response.data.Status === "0") {
              sethomePlans([]);
              setSerCat([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchHomePlans();
  }, [RendomTokenfetch, catid, limittype, planlimit]);
  return [homePlans, SerCat, loading, error];
};
/* =======Deshboard Plans All Plans =========*/
const AllGetDeshboardPlans = (
  RendomTokenfetch,
  catid,
  serviceid,
  userRoll,
  planlimit,
  limittype
) => {
  const [GetallPlans, setGetallPlans] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const FetchHomePlans = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("role_id", userRoll);
      fdata.append("cat_id", catid);
      fdata.append("service_id", serviceid);
      fdata.append("subservice_id", "");
      fdata.append("state_id", "");
      fdata.append("city_id", "");
      fdata.append("limit", planlimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}getAllPlan`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setGetallPlans(response.data.plandata || []);
            }
            if (response.data.Status === "0") {
              setGetallPlans([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchHomePlans();
  }, [RendomTokenfetch, catid, userRoll, planlimit, limittype, serviceid]);
  return [GetallPlans, loading, error];
};

const AllServicePlansData = async (
  RendomTokenfetch,
  catid,
  serviceid,
  Subserviceid,
  userRoll,
  planlimit,
  limittype
) => {
  try {
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("cat_id", catid);
    fdata.append("service_id", serviceid);
    fdata.append("subservice_id", Subserviceid);
    fdata.append("state_id", "");
    fdata.append("city_id", "");
    fdata.append("limit", planlimit);
    fdata.append("limittype", limittype);

    const response = await axios.post(`${WebsiteAPIurl}getAllPlan`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });
    // console.log(response.data);
    if (response.data.Status === "1") {
      return response.data.plandata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======Plans Details=========*/
const PlansDetails = (RendomTokenfetch, planslug, userRoll) => {
  const [plansdetails, setplansdetails] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetcPlansDetails = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("slug", planslug);
      fdata.append("role_id", userRoll);
      try {
        await axios
          .post(`${WebsiteAPIurl}planDetails`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setplansdetails(response.data.planData);
            }
            if (response.data.Status === "0") {
              setplansdetails("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetcPlansDetails();
  }, [RendomTokenfetch, planslug, userRoll]);
  return [plansdetails, loading, error];
};

/* =======Category All Services =========*/
const AllCatserviceSection = (
  RendomTokenfetch,
  catid,
  servicelimit,
  limittype
) => {
  const [Sectionservice, setSectionservice] = useState([]);
  const [SerCat, setSerCat] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetcServicesDetails = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("catid", catid);
      fdata.append("servicelimit", servicelimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setSectionservice(response.data.servicedata);
              setSerCat(response.data.catdata);
            }
            if (response.data.Status === "0") {
              setSectionservice([]);
              setSerCat([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetcServicesDetails();
  }, [RendomTokenfetch, catid, limittype, servicelimit]);
  return [Sectionservice, SerCat, loading, error];
};

/* =======All Payment Method =========*/
const AllPaymentMode = (RendomTokenfetch) => {
  const [Paymentmode, setPaymentmode] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const Fetcpaymentmod = async () => {
      setLoading(true);
      try {
        await axios
          .get(`${WebsiteAPIurl}allpayment_method`, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setPaymentmode(response.data.pmodedata);
            }
            if (response.data.Status === "0") {
              setPaymentmode("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    Fetcpaymentmod();
  }, [RendomTokenfetch]);
  return [Paymentmode, loading, error];
};

const GetwayPaymentMode = async (RendomTokenfetch) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    const response = await axios.post(`${WebsiteAPIurl}payment_mode`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });
    // console.log(response.data);
    if (response.data.Status === "1") {
      return response.data.payment_mode;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Leads =========*/
const AllserviceLeads = (RendomTokenfetch, servicelimit, limittype) => {
  const [Userlead, setUserlead] = useState([]);
  const [Status, setStatus] = useState("0");
  const [msg, setmsg] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchUserlead = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("limit", servicelimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}allLeads`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setUserlead(response.data.leaddata);
              setStatus(response.data.Status);
            }
            if (response.data.Status === "0") {
              setUserlead("");
              setStatus(response.data.Status);
              setmsg(response.data.message);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchUserlead();
  }, [RendomTokenfetch, limittype, servicelimit]);
  return [Userlead, Status, msg, loading, error];
};

const AllBookingLeads = async (
  RendomTokenfetch,
  servicelimit,
  limittype,
  leadID,
  catID,
  serviceID
) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("limit", servicelimit);
    fdata.append("limittype", limittype);
    fdata.append("leadid", leadID);
    fdata.append("catid", catID);
    fdata.append("serviceid", serviceID);

    const response = await axios.post(`${WebsiteAPIurl}allLeads`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });

    if (response.data.Status === "1") {
      return response.data.leaddata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All User Leads Details=========*/
const AllLeadsdetails = (RendomTokenfetch, leadid) => {
  const [leaddetails, setleaddetails] = useState([]);
  const [leadComment, setleadComment] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchUserlead = async () => {
      setLoading(true);
      setError(null);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("lead_id", leadid);
      try {
        await axios
          .post(`${WebsiteAPIurl}lead_details`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setleaddetails(response.data.leaddata);
              setleadComment(response.data.commentdata);
            }
            if (response.data.Status === "0") {
              setleaddetails("");
              setleadComment("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (RendomTokenfetch && leadid) {
      FetchUserlead();
    }
  }, [RendomTokenfetch, leadid]);
  return [leaddetails, leadComment, loading, error];
};

/* =======All Lead Users Comments  Data=========*/
const AllLeadUserComments = async (RendomTokenfetch, leadid) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("lead_id", leadid);

    const response = await axios.post(`${WebsiteAPIurl}lead_details`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });

    if (response.data.Status === "1") {
      return response.data.commentdata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Vendor Leads Details=========*/
const AllVendorLeadsdetails = (RendomTokenfetch, leadid) => {
  const [leaddetails, setleaddetails] = useState([]);
  const [leadComment, setleadComment] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchUserlead = async () => {
      setLoading(true);
      setError(null);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("lead_id", leadid);
      try {
        await axios
          .post(`${WebsiteAPIurl}lead_detailsVendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setleaddetails(response.data.leaddata);
              setleadComment(response.data.commentdata);
            }
            if (response.data.Status === "0") {
              setleaddetails("");
              setleadComment("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (RendomTokenfetch && leadid) {
      FetchUserlead();
    }
  }, [RendomTokenfetch, leadid]);
  return [leaddetails, leadComment, loading, error];
};

const AllVendorLeadsdetail = async (RendomTokenfetch, leadid) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("lead_id", leadid);

    const response = await axios.post(
      `${WebsiteAPIurl}lead_detailsVendor`,
      fdata,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );

    if (response.data.Status === "1") {
      return response.data.leaddata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Lead Vendor Comments  Data=========*/
const AllLeadVendorComments = async (RendomTokenfetch, leadid) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("lead_id", leadid);

    const response = await axios.post(
      `${WebsiteAPIurl}lead_detailsVendor`,
      fdata,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
    // console.log(response);
    if (response.data.Status === "1") {
      return response.data.commentdata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======AllLeadsStatusStepper=========*/
// const AllLeadsStatusStepper = (RendomTokenfetch, leadid, servicID) => {
//   const [leadStatusStepper, setleadStatusStepper] = useState([]);
//   const [StepperLength, setStepperLength] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const FetchUserlead = async () => {
//       setLoading(true);
//       let fdata = new FormData();
//       fdata.append("lead_id", leadid);
//       fdata.append("service_id", servicID);
//       try {
//         await axios
//           .post(`${WebsiteAPIurl}leadstatusAjex`, fdata, {
//             headers: {
//               Authorization: RendomTokenfetch,
//             },
//           })
//           .then((response) => {
//             // console.log(response.data.length);s
//             if (response.data.Status === "1") {
//               setleadStatusStepper(response.data.statusdata);
//               setStepperLength(response.data.statusdata.length);
//             }
//             if (response.data.Status === "0") {
//               setleadStatusStepper("");
//             }
//           });
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     FetchUserlead();
//   }, [RendomTokenfetch, leadid, servicID]);
//   return [leadStatusStepper, StepperLength, loading, error];
// };

const AllLeadsStatusStepper = async (RendomTokenfetch, leadid, servicID) => {
  try {
    let fdata = new FormData();
    fdata.append("lead_id", leadid);
    fdata.append("service_id", servicID);

    const response = await axios.post(`${WebsiteAPIurl}leadstatusAjex`, fdata, {
      headers: {
        Authorization: RendomTokenfetch,
      },
    });

    if (response.data.Status === "1") {
      return response.data.statusdata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Deshbord Count=========*/
const AllDeshbordCountData = (RendomTokenfetch) => {
  const [deshbordCount, setdeshbordCount] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!userID) {
      setError("User ID not found in localStorage");
      return;
    }
    const FetchDeshbordCount = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      try {
        await axios
          .post(`${WebsiteAPIurl}dashboard_counter`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setdeshbordCount(response.data.counterdata);
            }
            if (response.data.Status === "0") {
              setdeshbordCount("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchDeshbordCount();
  }, [RendomTokenfetch]);
  return [deshbordCount, loading, error];
};

/* ======= Vendor Request/Response Data=========*/
const VendorResponseData = (RendomTokenfetch) => {
  const [vendorresponse, setvendorresponse] = useState([]);
  const [responseStatus, setresponseStatus] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!userID) {
      setError("User ID not found in localStorage");
      return;
    }
    const FetchresponseData = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      try {
        await axios
          .post(`${WebsiteAPIurl}vendor_requestdata`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            setresponseStatus(response.data.Status);
            if (response.data.Status === "1") {
              setvendorresponse(response.data.requestdata);
            }
            if (response.data.Status === "0") {
              setvendorresponse("");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchresponseData();
  }, [RendomTokenfetch]);
  return [responseStatus, vendorresponse, loading, error];
};

// const VendorResponseData = async (RendomTokenfetch) => {
//   try {
//     let fdata = new FormData();
//     fdata.append("user_id", userID);

//     const response = await axios.post(
//       `${WebsiteAPIurl}vendor_requestdata`,
//       fdata,
//       {
//         headers: {
//           Authorization: RendomTokenfetch,
//         },
//       }
//     );

//     if (response.data.Status === "1") {
//       console.log(response.data);
//       return response.data.requestdata;
//     } else {
//       return [];
//     }
//   } catch (err) {
//     console.error("Error fetching Data:", err);
//     return [];
//   }
// };

/* =======All Vandor Category And Status Priority  Data=========*/
const AllvendorCategoryPriorty = (RendomTokenfetch) => {
  // const [vendorCat, setvendorCat] = useState([]);
  const [statusPriority, setstatusPriority] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getallcategoryvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              // setvendorCat(response.data.catdata);
              setstatusPriority(response.data.statuspriority);
            } else {
              // setvendorCat("");
              setstatusPriority([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorcatData();
  }, [RendomTokenfetch]);
  return [statusPriority, error, loading];
};

/* =======All Vandor Category Wise Services  Data=========*/
const AllvendorCatService = (RendomTokenfetch, catID) => {
  const [vendorService, setvendorService] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", catID);
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setvendorService(response.data.servicedata);
            } else {
              setvendorService("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, catID]);
  return [vendorService, error, loading];
};

/* =======All Vandor Sub Services And  State Data=========*/
const AllStateSubservice = (RendomTokenfetch, catID, serviceID) => {
  const [subService, setsubService] = useState([]);
  const [serviceState, setserviceState] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("serviceid", serviceID);
    fdata.append("catid", catID);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}StateAndSubservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setsubService(response.data.servicedata);
              setserviceState(response.data.statedata);
            } else {
              setsubService("");
              setserviceState("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchSubServiceStateData();
  }, [RendomTokenfetch, serviceID, catID]);
  return [subService, serviceState, error, loading];
};
/* =======All Vandor Service City Data=========*/
const AllServiceCity = (RendomTokenfetch, catID, serviceID, stateID) => {
  const [serviceCity, setserviceCity] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", catID);
    fdata.append("serviceid", serviceID);
    fdata.append("stateid", stateID);

    const FetchServiceCityData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getServiceStateCity`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setserviceCity(response.data.citydata);
            } else {
              setserviceCity("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServiceCityData();
  }, [RendomTokenfetch, serviceID, catID, stateID]);
  return [serviceCity, error, loading];
};

/* =======All Vandor Category Wise Services  Data=========*/
const AllServiceDetailsPlans = (RendomTokenfetch, serviceslug) => {
  const [detailsServicePlan, setdetailsServicePlan] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("serviceslug", serviceslug);
    const FetchServicePlansData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setdetailsServicePlan(response.data.servicedata);
            } else {
              setdetailsServicePlan("");
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServicePlansData();
  }, [RendomTokenfetch, serviceslug]);
  return [detailsServicePlan, error, loading];
};

/* =======All Total Leads  Cat And Services Wise=========*/
const AllCatServiceLeads = (RendomTokenfetch, catID, serviceID) => {
  const [Totallead, setTotallead] = useState([]);
  const [Status, setStatus] = useState("0");
  const [msg, setmsg] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchVendorlead = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("cat_id", catID);
      fdata.append("service", serviceID);
      try {
        await axios
          .post(`${WebsiteAPIurl}catServiceAlllead`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setTotallead(response.data.leaddata);
              setStatus(response.data.Status);
            }
            if (response.data.Status === "0") {
              setTotallead("");
              setStatus(response.data.Status);
              setmsg(response.data.message);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorlead();
  }, [RendomTokenfetch, catID, serviceID]);
  return [Totallead, Status, msg, loading, error];
};
/* =======All Claim Total Leads  Cat And Services Wise=========*/
// const AllClaimLeads = (RendomTokenfetch, catID, serviceID) => {
//   const [Totallead, setTotallead] = useState([]);
//   const [Status, setStatus] = useState("0");
//   const [msg, setmsg] = useState("");
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const FetchVendorlead = async () => {
//       setLoading(true);
//       let fdata = new FormData();
//       fdata.append("user_id", userID);
//       fdata.append("category", catID);
//       fdata.append("service", serviceID);
//       try {
//         await axios
//           .post(`${WebsiteAPIurl}getallNotassignLead`, fdata, {
//             headers: {
//               Authorization: RendomTokenfetch,
//             },
//           })
//           .then((response) => {
//             // console.log(response.data);
//             if (response.data.Status === "1") {
//               setTotallead(response.data.leaddata);
//               setStatus(response.data.Status);
//             }
//             if (response.data.Status === "0") {
//               setTotallead("");
//               setStatus(response.data.Status);
//               setmsg(response.data.message);
//             }
//           });
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     FetchVendorlead();
//   }, [RendomTokenfetch, catID, serviceID]);
//   return [Totallead, loading, Status, msg, error];
// };

const AllClaimLeads = async (RendomTokenfetch, catID, serviceID) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("category", catID);
    fdata.append("service", serviceID);

    const response = await axios.post(
      `${WebsiteAPIurl}getallNotassignLead`,
      fdata,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );

    if (response.data.Status === "1") {
      return response.data.leaddata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Vendor Leads =========*/
const AllVendorLeads = (RendomTokenfetch, servicelimit, limittype) => {
  const [Vendorlead, setVendorlead] = useState([]);
  const [Status, setStatus] = useState("0");
  const [msg, setmsg] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchVendorlead = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("limit", servicelimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}allLeadsvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setVendorlead(response.data.leaddata);
              setStatus(response.data.Status);
            }
            if (response.data.Status === "0") {
              setVendorlead("");
              setStatus(response.data.Status);
              setmsg(response.data.message);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorlead();
  }, [RendomTokenfetch, limittype, servicelimit]);
  return [Vendorlead, Status, msg, loading, error];
};

/* =======All News Paper Vendor  =========*/
const AllNewspaperVendor = (RendomTokenfetch, servicelimit, limittype) => {
  const [Vendorstatuscount, setVendorstatuscount] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchVendorlead = async () => {
      setLoading(true);
      const params = new URLSearchParams({
        userid: userID,
        limit: servicelimit,
        limittype: limittype,
      });

      try {
        const response = await axios.get(
          `${WebsiteAPIurl}getVendorNewsList?${params.toString()}`,
          {
            headers: {
              Authorization: RendomTokenfetch,
            },
          }
        );
        // console.log(response.data);
        if (response.data.Status === "1") {
          setVendorstatuscount(response.data.statuscount);
        } else {
          setVendorstatuscount([]);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorlead();
  }, [RendomTokenfetch, limittype, servicelimit]);
  return [Vendorstatuscount, loading, error];
};

const AllNewspaperVendorData = async (
  RendomTokenfetch,
  startdate,
  endDate,
  workstatus,
  vendorWorkstatus,
  Requeststatus
) => {
  try {
    const params = new URLSearchParams({
      userid: userID,
      limit: "5",
      limittype: "0",
      startdate: startdate,
      enddate: endDate,
      workstatus: workstatus,
      vendorWorkstatus: vendorWorkstatus,
      Requeststatus: Requeststatus,
    });

    const response = await axios.get(
      `${WebsiteAPIurl}getVendorNewsList?${params.toString()}`,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
    // console.log(response.data);
    if (response.data.Status === "1") {
      return response.data.newsdata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

/* =======All Vendor Leads =========*/
const NewsPaperVendorData = (RendomTokenfetch, newsid) => {
  const [NewsVendorData, setNewsVendorData] = useState([]);
  const [Status, setStatus] = useState("0");
  const [msg, setmsg] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchVendorlead = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("news_id", newsid);
      try {
        await axios
          .post(`${WebsiteAPIurl}vendorNewsDetails`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setNewsVendorData(response.data.newsData);
              setStatus(response.data.Status);
            }
            if (response.data.Status === "0") {
              setNewsVendorData([]);
              setStatus(response.data.Status);
              setmsg(response.data.message);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorlead();
  }, [RendomTokenfetch, newsid]);
  return [NewsVendorData, Status, msg, loading, error];
};

/* =======All Vendor Working Leads =========*/
const AllVendorWorkingLeads = (RendomTokenfetch, servicelimit, limittype) => {
  const [Vendorlead, setVendorlead] = useState([]);
  const [Status, setStatus] = useState("0");
  const [msg, setmsg] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const FetchVendorlead = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("limit", servicelimit);
      fdata.append("limittype", limittype);
      try {
        await axios
          .post(`${WebsiteAPIurl}allLeadsvendorworking`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              setVendorlead(response.data.leaddata);
              setStatus(response.data.Status);
            } else {
              setVendorlead("");
              setStatus(response.data.Status);
              setmsg(response.data.message);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorlead();
  }, [RendomTokenfetch, limittype, servicelimit]);
  return [Vendorlead, Status, msg, loading, error];
};

const AllWorkingLeads = async (RendomTokenfetch) => {
  try {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("limit", "5");
    fdata.append("limittype", "0");

    const response = await axios.post(
      `${WebsiteAPIurl}allLeadsvendorworking`,
      fdata,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );

    if (response.data.Status === "1") {
      return response.data.leaddata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

//All Lead Vendor Working
const AllGETWorkingLeads = async (
  RendomTokenfetch,
  startdate,
  endDate,
  workstatus
) => {
  try {
    const params = new URLSearchParams({
      user_id: userID,
      limit: "5",
      limittype: "0",
      start_date: startdate,
      end_date: endDate,
      status: workstatus,
    });

    const response = await axios.get(
      `${WebsiteAPIurl}allLeadsvendorworking?${params.toString()}`,
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
    console.log(response.data);
    if (response.data.Status === "1") {
      return response.data.leaddata;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching Data:", err);
    return [];
  }
};

// Start
/*============================Home Homedefaultserviceplan================*/

const Homedefaultserviceplan = (defaultServiceid) => {
  const [Defaultservice, setDefaultservice] = useState([]);
  const [Defaultplan, setDefaultplan] = useState([]);
  useEffect(() => {
    const FetchDefaultplan = async () => {
      await axios
        .get(`${Base_url}serviceapi/homedefaultserviceplan/${defaultServiceid}`)
        .then((res) => {
          if (res.data.status === "1") {
            // alert(res.data.msg);
            setDefaultservice(res.data.servicedata);
            setDefaultplan(res.data.serviceplan);
          }
        });
    };
    FetchDefaultplan();
  }, [defaultServiceid]);
  return [Defaultservice, Defaultplan];
};
/* =======Home Plans Tabs=========*/
const HomePlanstabs = () => {
  const [PlanTabsHome, setPlanTabsHome] = useState([]);
  useEffect(() => {
    const FetchPlanTabsHome = async () => {
      await axios.get(`${Base_url}serviceapi/homeplanservice`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setPlanTabsHome(res.data.service);
        }
      });
    };
    FetchPlanTabsHome();
  }, []);
  return [PlanTabsHome];
};
/* =======Home Services Plans=========*/
const HomeServicesPlans = (IDService) => {
  const [HomeServicePlan, setHomeServicePlan] = useState([]);
  useEffect(() => {
    const FetchHomeServicesPlan = async () => {
      await axios
        .get(`${Base_url}serviceapi/planservicedetail/${IDService}`)
        .then((res) => {
          if (res.data.status === "1") {
            // alert(res.data.msg);
            setHomeServicePlan(res.data.serviceplan);
          }
        });
    };
    FetchHomeServicesPlan();
  }, [IDService]);
  return [HomeServicePlan];
};

/* =======All Pages Pageslist=========*/
const Allpageslist = () => {
  const [AllPage, setAllPage] = useState([]);
  useEffect(() => {
    const FetchAllPages = async () => {
      await axios.get(`${Base_url}settingapi/pageslist`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setAllPage(res.data.pageslist);
        }
      });
    };
    FetchAllPages();
  }, []);
  return [AllPage];
};
/* =======All Pages Data/ MetaTags=========*/
const AllPagesDatas = (pageid) => {
  const [AllPageData, setAllPageData] = useState([]);
  useEffect(() => {
    const FetchAllPagesMeta = async () => {
      await axios
        .get(`${Base_url}settingapi/pagedata/${pageid}`)
        .then((res) => {
          if (res.data.status === "1") {
            // alert(res.data.msg);
            setAllPageData(res.data.pagedata);
          }
        });
    };
    FetchAllPagesMeta();
  }, [pageid]);
  return [AllPageData];
};

/* =======Home Blogs=========*/
const HomeBlog = () => {
  const [HomeBlogs, setHomeBlogs] = useState([]);
  const [Loading, setLoading] = useState(false);
  useEffect(() => {
    const FetchHomeBlog = async () => {
      setLoading(true);
      await axios.get(`${Base_url}settingapi/homeblogs`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setHomeBlogs(res.data.blogs);
        }
      });
      setLoading(false);
    };
    FetchHomeBlog();
  }, []);
  return [HomeBlogs, Loading];
};
/* =======BlogPage Blogs=========*/
const BlogPageBlog = () => {
  const [Blogs, setBlogsdata] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    const FetchBlog = async () => {
      setLoading(true);
      await axios.get(`${Base_url}settingapi/blogs`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setBlogsdata(res.data.blogs);
        }
      });
      setLoading(false);
    };
    FetchBlog();
  }, []);
  return [Blogs, Loading];
};

/* =======BlogPage LangBlog=========*/
const BlogPageLangBlog = (langu) => {
  const [LangBlogs, setLangBlogs] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    const FetchLangBlog = async () => {
      setLoading(true);
      await axios
        .get(`${Base_url}settingapi/languageblogs/${langu}`)
        .then((res) => {
          if (res.data.status === "1") {
            // alert(res.data.msg);
            setLangBlogs(res.data.blogs);
          }
        });
      setLoading(false);
    };
    FetchLangBlog();
  }, [langu]);
  return [LangBlogs, Loading];
};

/* =======Blog All Languages=========*/
const BlogLanguage = () => {
  const [Language, setLanguage] = useState([]);
  useEffect(() => {
    const FetchBlogLanguage = async () => {
      await axios.get(`${Base_url}settingapi/alllanguages`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setLanguage(res.data.alllanguages);
        }
      });
    };
    FetchBlogLanguage();
  }, []);
  return [Language];
};
/* =======Blog Languages MetaTags=========*/
const LanguageMetaTags = (langu) => {
  const [LanguageMeta, setLanguageMeta] = useState([]);
  useEffect(() => {
    const FetchLanguageMeta = async () => {
      await axios.get(`${Base_url}settingapi/alllanguages`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          const resData = res.data.alllanguages;
          const resFilter = resData.filter((langcat) => {
            return langcat.language === langu;
          });
          const jsonLang = JSON.parse(JSON.stringify(resFilter[0]));
          setLanguageMeta(jsonLang);
        }
      });
    };
    FetchLanguageMeta();
  }, [langu]);
  return [LanguageMeta];
};

/* =======Blog Details=========*/
const DetailsBlog = (slug) => {
  const navigaṭe = useNavigate();
  const [Blogdetails, setBlogdetails] = useState([]);
  useEffect(() => {
    const FetchBlogDetails = async () => {
      await axios

        .get(`${Base_url}settingapi/blogdetail/${slug}`)
        .then((res) => {
          if (res.data.status === "1") {
            // alert(res.data.msg);
            setBlogdetails(res.data.blogdetail);
          }
          if (res.data.status === "0") {
            // alert(res.data.msg);
            navigaṭe("/page-not-found");
          }
        });
    };
    FetchBlogDetails();
  }, [slug, navigaṭe]);
  return [Blogdetails];
};

/* =======All Services=========*/
const AllServices = () => {
  const [ServicesAll, setServicesAll] = useState([]);
  useEffect(() => {
    const FetcAllServices = async () => {
      await axios.get(`${Base_url}serviceapi/allservice`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setServicesAll(res.data.service);
        }
      });
    };
    FetcAllServices();
  }, []);
  return [ServicesAll];
};
/* =======Footer Services=========*/
const FootServices = () => {
  const [ServicesFooter, setServicesFooter] = useState([]);
  useEffect(() => {
    const FetcFooterServices = async () => {
      await axios.get(`${Base_url}serviceapi/footerservice`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setServicesFooter(res.data.service);
        }
      });
    };
    FetcFooterServices();
  }, []);
  return [ServicesFooter];
};
/* =======Services Plans=========*/
const ServicesPlans = () => {
  const [ServicePlan, setServicePlan] = useState([]);
  useEffect(() => {
    const FetchServicesPlan = async () => {
      await axios.get(`${Base_url}serviceapi/serviceplan`).then((res) => {
        if (res.data.status === "1") {
          // alert(res.data.msg);
          setServicePlan(res.data.serviceplan);
        }
      });
    };
    FetchServicesPlan();
  }, []);
  return [ServicePlan];
};

export default WebsiteSetting;
export {
  UserProfileData,
  AllServicesCategory,
  ServiceCatWise,
  SingleCatName,
  Homesetting,
  AllCatserviceSection,
  ServicesDetails,
  AllPaymentMode,
  AllserviceLeads,
  AllBookingLeads,
  AllLeadsdetails,
  AllLeadUserComments,
  AllVendorLeadsdetails,
  AllVendorLeadsdetail,
  AllLeadVendorComments,
  AllLeadsStatusStepper,
  AllClaimLeads,
  AllDeshbordCountData,
  VendorResponseData,
  AllvendorCategoryPriorty,
  AllvendorCatService,
  AllStateSubservice,
  AllServiceCity,
  AllCatServiceLeads,
  AllVendorLeads,
  AllGETWorkingLeads,
  AllNewspaperVendor,
  AllNewspaperVendorData,
  NewsPaperVendorData,
  AllVendorWorkingLeads,
  AllWorkingLeads,
  AllServiceDetailsPlans,
  AllHomeDefaultPlans,
  AllGetDeshboardPlans,
  PlansDetails,
  AllServicePlansData,
  Homedefaultserviceplan,
  HomePlanstabs,
  GetwayPaymentMode,
  HomeServicesPlans,
  AllCommunityService,
  AllCommunityServiceQuestion,
  AllCommunityAnswear,
  AllIndiaCity,
  AllCommunityAnswearLike,
  AllCustomersUploads,
  AllVendorsUploads,
  AllCustumertUploads,
  HomeBlog,
  BlogPageBlog,
  Allpageslist,
  AllPagesDatas,
  BlogPageLangBlog,
  BlogLanguage,
  LanguageMetaTags,
  DetailsBlog,
  AllServices,
  ServicesPlans,
  FootServices,
};
